import React, { useEffect, useMemo, useRef, useState } from "react";
import BaseButton from "Components/Base/BaseButton";
import { BaseSelect } from "Components/Base/BaseSelect";
import {
  checkStatusCodeSuccess,
  notFound,
  rupeeSymbol,
  TaxType,
} from "Components/constants/Common";
import { useFormik } from "formik";
import {
  NoLabel,
  submitLabel,
  updateLabel,
  YesLabel,
} from "Components/constants/Role";
import { getRONumberList } from "Api/RepairOrderOpen";
import { toast } from "react-toastify";
import {
  getViewPR,
  getViewPRWORO,
  listOfItemCode,
  listOfProductForItem,
  listOfProject,
} from "Api/PartRequisition";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import * as yup from "yup";
import Loader from "Components/Base/BaseLoader";
import {
  ADD_RATE_LABEL,
  EDIT_PURCHASE_ORDER_LABEL,
  NEW_PURCHASE_ORDER_LABEL,
  VIEW_PURCHASE_ORDER_LABEL,
} from "Components/constants/RoPurchaseOrder";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { vendorLabel } from "Components/constants/Vendor";
import { listOfVendor } from "Api/Vendor";
import {
  addPOwithRO,
  addRate,
  getViewPO,
  getViewPOWORO,
  listOfRate,
  listOfStock,
  updatePO,
} from "Api/RoPurchaseOrder";
import { amountCountApi } from "Api/Quotation";
import { QuotationLabel } from "Components/constants/Quotation";
import {
  ADD_NEW_MAKE,
  ALL_FIELDS_ARE_REQUIRED,
  AMOUNT_LABEL,
  GST_LABEL,
  ITEM_CODE_LABEL,
  ITEM_DESC_LABEL,
  MAKE_KEY,
  MAKE_LABEL,
  MAKE_NAME,
  MATERIAL_DESC_LABEL,
  MATERIAL_GRP_LABEL,
  MATERIAL_TYPE_LABEL,
  PLEASE_SELECT_ONE_ROW,
  PROJECT_NAME_LABEL,
  RACK_LOCA_LABEL,
  RAMARKS_LABEL,
  RATE_LABEL,
  REQUESTED_QTY_LABEL,
  REQUIRED_STOCK_LABEL,
  RO_NO_LABEL,
  SELECT_ITEM_CODE,
  SELECT_LABEL,
  SR_NO_LABEL,
  STOCK_LABEL,
  STORE_LOCA_LABEL,
  UOM_LABEL,
  VENDOR_ID_LABEL,
  VENDOR_NAME_LABEL,
} from "Components/constants/ROModule";
import { 
  TERMS_AND_CONDITIONS_LABEL, 
  EDIT_TERMS_LABEL, 
  SAVE_TERMS_LABEL, 
  CANCEL_TERMS_LABEL,
  DEFAULT_TERMS_AND_CONDITIONS 
} from "Components/constants/RoPurchaseOrder";
import { createManufacturer, listOfManufacturer } from "Api/ManuFacturer";
import BaseInput from "Components/Base/BaseInput";
import { addMakeLabel } from "Components/constants/ManuFacturer";
import BaseModal from "Components/Base/BaseModal";
import {
  InputPlaceHolder,
  validationMessages,
} from "Components/constants/validation";
import Select from "react-select";

interface Vendor {
  id: number;
  value: number;
  label: string;
  user_draft_id: string;
  countAmount: any;
}

const ItemCodeEditor = ({ params }: { params: any }) => {
  const itemCodes = params.itemCodes || [];

  const formattedItemCodes = itemCodes.map((item: any) => {
    if (typeof item === "object" && item.value && item.label) {
      return item;
    }

    if (typeof item === "object" && item.value) {
      return {
        value: String(item.value),
        label: String(item.value),
      };
    }

    return {
      value: String(item),
      label: String(item),
    };
  });

  const handleChange = (selectedOption: any) => {
    params.stopEditing();

    if (!selectedOption) {
      const resetData = {
        ...params.data,
        tempId: params.data.tempId,
        srNo: params.data.srNo,
        item_code: "",
        parts_name: "",
        uom: "",
        stock: "",
        make: "",
        manufacturer_id: null,
        product_variant_id: null,
        product_id: null,
        material_type: "",
        material_group: "",
        material_group_description: "",
        store_location: "",
        rack_location: "",
        qty: "",
        project_name: "",
        project_id: null,
        remarks: "",
        isExcludePo: false,
      };

      if (params.context.updateRowData) {
        params.context.updateRowData(params.rowIndex, resetData);
      }

      params.api.applyTransaction({
        update: [resetData],
      });

      return;
    }

    const optionValue = selectedOption?.value ?? "";
    let label = selectedOption?.label ?? "";
    let id = optionValue;

    if (typeof optionValue === "string" && optionValue.includes("|")) {
      const parts = optionValue.split("|");
      label = parts[0];
      id = parts[1] || label;
    }

    params.node.setDataValue("item_code", label);
    params.context.handleProductSelect(label, params.rowIndex, Number(id));
  };

  const selectedItemCode = formattedItemCodes.find(
    (item: { value: string; label: string }) => item.label === params.value
  );

  return (
    <Select
      name="item_code"
      options={formattedItemCodes}
      value={selectedItemCode || null}
      onChange={handleChange}
      placeholder={SELECT_ITEM_CODE}
      menuPosition="fixed"
      menuPlacement="auto"
      isClearable={true}
      styles={{
        control: (provided: any) => ({
          ...provided,
          width: "180px",
        }),
        menu: (provided: any) => ({
          ...provided,
          width: "180px",
        }),
      }}
    />
  );
};

const RoPOForm = () => {
  const [loader, setLoader] = useState<boolean>(false);
  const [viewPR, setViewPR] = useState<any[]>([]);
  const [selectedRONo, setSelectedRONo] = useState<any | null>(null);
  const [btnLoader, setBtnLoader] = useState(false);
  const [RONumberList, setRONumberList] = useState<any[]>([]);
  const [itemCodes, setItemCodes] = useState<any[]>([]);
  const [projectNames, setProjectNames] = useState<any[]>([]);
  const gridRef = useRef<AgGridReact<any>>(null);
  const { id, prid, poid } = useParams<{
    id: string;
    prid: string;
    poid: string;
  }>();
  const location = useLocation();
  const isViewMode = location.pathname.includes("viewRoPurchaseOrder");
  let validationSchema = yup.object({});
  const [columnName, setColumnName] = useState("id");
  const [sortOrder, setSortOrder] = useState("desc");
  const [currentPage, setCurrentPage] = useState(1);
  const [customPageSize, setCustomPageSize] = useState(1000);
  const [vendorData, setVendorData] = useState<any[]>([]);
  const [selectedVendor, setSelectedVendor] = useState<Vendor | null>(null);
  const [totalAmount, setTotalAmount] = useState<number>(0);
  const [poDetails, setPODetails] = useState<any>(null);
  const [partId, setPartId] = useState<number | null>(null);
  const navigate = useNavigate();
  const isPRRoute = location.pathname.includes("addPurchaseOrder");
  const isEditPORoute = location.pathname.includes("editPurchaseOrder");
  const isViewPORoute = location.pathname.includes("viewPurchaseOrder");
  const isViewPRRoute = location.pathname.includes("editPartRequisitionWORo");
  const [currentEditingCell, setCurrentEditingCell] = useState<{
    rowIndex: number;
    productId: number | null;
    manufacturerId: number | null;
    itemId: number | null;
  } | null>(null);

  if (!isPRRoute && !isEditPORoute) {
    validationSchema = validationSchema.shape({
      RONumber: yup.string().required(validationMessages.required(RO_NO_LABEL)),
    });
  }
  const rateValidationSchema = yup.object().shape({
    rate: yup.number().required(validationMessages.required(RATE_LABEL)),
  });
  const makeValidationSchema = yup.object().shape({
    name: yup.string().required(validationMessages.required(MAKE_LABEL)),
  });

  const getPageTitle = () => {
    if (isViewPORoute) return VIEW_PURCHASE_ORDER_LABEL;
    if (isEditPORoute) return EDIT_PURCHASE_ORDER_LABEL;
    if (isPRRoute) return NEW_PURCHASE_ORDER_LABEL;
    if (isViewMode) return VIEW_PURCHASE_ORDER_LABEL;
    if (id) return EDIT_PURCHASE_ORDER_LABEL;
    return NEW_PURCHASE_ORDER_LABEL;
  };
  const label = isPRRoute
    ? submitLabel
    : isEditPORoute
    ? updateLabel
    : id
    ? updateLabel
    : submitLabel;
  const [makeOption, setMakeOption] = useState<Array<any>>([]);
  const [makeModal, setMakeModal] = useState<boolean>(false);
  const [modalLoader, setModalLoader] = useState<boolean>(false);
  const [rateOptions, setRateOptions] = useState<
    Record<
      number,
      Array<{
        label: string;
        value: string;
        id: number;
      }>
    >
  >({});
  const [rateModal, setRateModal] = useState<boolean>(false);
  const [submitModalOpen, setSubmitModalOpen] = useState<boolean>(false);
  const [pendingSubmitValues, setPendingSubmitValues] = useState<any>(null);
  const [termsAndConditions, setTermsAndConditions] = useState<string>(DEFAULT_TERMS_AND_CONDITIONS);
  const [isEditingTerms, setIsEditingTerms] = useState<boolean>(false);
  const [tempTerms, setTempTerms] = useState<string>(DEFAULT_TERMS_AND_CONDITIONS);
  const termsList = useMemo(() => {
    try {
      const jsonData = termsAndConditions?.trim();
      if (jsonData && jsonData.startsWith("[") && jsonData.endsWith("]")) {
        const parsed = JSON.parse(jsonData);
        if (Array.isArray(parsed)) {
          return parsed.map((t: any) => String(t)).map(t => t.replace(/^\d+\.?\s*/, '').trim()).filter(Boolean);
        }
      }
    } catch {}
    return (termsAndConditions || '')
      .split('\n')
      .map(t => t.replace(/^\d+\.?\s*/, '').trim())
      .filter(Boolean);
  }, [termsAndConditions]);

  const fetchPRDetailsById = (part_id: number, isExcludePo: boolean) => {
    setLoader(true);
    getViewPRWORO({ part_id, isExcludePo })
      .then((res) => {
        if (checkStatusCodeSuccess(res?.statusCode)) {
          const data = res?.data;

          if (Array.isArray(data) && data.length > 0) {
            const allItems = data.flatMap(
              (item) => item.partRequisitionItem || []
            );
            const partId = data[0]?.id;

            setPartId(partId);

            const formattedData = allItems.map((item, index) => ({
              srNo: index + 1,
              id: item.id,
              item_id: item.id,
              product_id: item.product_id || null,
              item_code: item.item_code || "",
              parts_name: item.parts_name || "",
              uom: item.uom || "",
              qty: item.qty || "",
              stock: item.productVariant?.quantity || 0,
              store_location: item.store_location || "",
              project_name: item.project?.project_name || "",
              project_id: item.project?.id || null,
              rack_location: item.rack_location || "",
              remarks: item.remarks || "",
              material_type: item.material_type || "",
              make: item.productVariant?.manufacturer?.name || "",
              manufacturer_id: item.productVariant?.manufacturer_id || "",
              product_variant_id: item.productVariant?.id || null,
              material_group: item.material_group || "",
              material_group_description: item.material_group_description || "",
              isExcludePo: item.isExcludePo,
            }));

            setViewPR(formattedData);
            formattedData.forEach((item) => {
              if (item.product_id && item.manufacturer_id) {
                fetchRateForProduct(item.product_id, item.manufacturer_id);
              }
            });
          } else {
            setViewPR([]);
          }
        } else {
          //keep commented to hide the error message
          // toast.error(res.message);
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message || err?.message);
      })
      .finally(() => {
        setLoader(false);
      });
  };

  const fetchRODetailsById = (ro_id: number, isExcludePo: boolean) => {
    setLoader(true);
    getViewPR({ ro_id, isExcludePo })
      .then((res) => {
        if (checkStatusCodeSuccess(res?.statusCode)) {
          const data = res?.data;

          if (Array.isArray(data) && data.length > 0) {
            const allItems = data.flatMap(
              (item) => item.partRequisitionItem || []
            );

            const partId = data[0]?.id;
            setPartId(partId);

            const formattedData = allItems.map((item, index) => ({
              srNo: index + 1,
              ro_id: item.ro_id,
              id: item.id,
              item_id: item.id,
              product_id: item.product_id || null,
              item_code: item.item_code || "",
              parts_name: item.parts_name || "",
              uom: item.uom || "",
              qty: item.qty || "",
              stock: item.productVariant?.quantity || 0,
              make: item.productVariant?.manufacturer?.name || "",
              manufacturer_id: item.manufacturer_id,
              product_variant_id: item.productVariant?.id || null,
              store_location: item.store_location || "",
              project_name: item.project?.project_name || "",
              project_id: item.project?.id || null,
              rack_location: item.rack_location || "",
              remarks: item.remarks || "",
              material_type: item.material_type || "",
              material_group: item.material_group || "",
              material_group_description: item.material_group_description || "",
              isExcludePo: true,
            }));

            setViewPR(formattedData);

            formattedData.forEach((item) => {
              if (item.product_id && item.manufacturer_id) {
                fetchRateForProduct(item.product_id, item.manufacturer_id);
              }
            });
          } else {
            setViewPR([]);
          }
        } else {
          //keep commented to hide the error message
          // toast.error(res.message);
        }
      })
      .catch((err) => {})
      .finally(() => {
        setLoader(false);
      });
  };

  const fetchPOWORODetailsById = (poid: any) => {
    setLoader(true);
    getViewPOWORO(poid)
      .then((res) => {
        if (checkStatusCodeSuccess(res?.statusCode)) {
          const data = res?.data;
          setPODetails(data);
          setPartId(data.part_id);

          if (
            data.repairOrderPurchaseOrderItem &&
            data.repairOrderPurchaseOrderItem.length > 0
          ) {
            setRONumberList([
              {
                label: data.repairOrderPurchaseOrderItem[0]?.ro_po_id || "N/A",
                value: data.repairOrderPurchaseOrderItem[0]?.ro_po_id || "N/A",
              },
            ]);

            setTimeout(() => {
              formik.setFieldValue(
                "RONumber",
                data.repairOrderPurchaseOrderItem[0]?.ro_po_id || ""
              );
            }, 0);
          }

          if (data.vendor) {
            setSelectedVendor({
              id: data.vendor.id,
              value: data.vendor.id,
              label: data.vendor.name,
              user_draft_id: data.user_draft_id,
              countAmount: 0,
            });
          }

          const transformedItems = data.repairOrderPurchaseOrderItem.map(
            (item: any) => ({
              ...item,
              id: item.id,
              item_id: item.id,
              item_code: item.productVariant?.product?.product_code,
              product_id: item.product_id,
              material_description:
                item.partRequisitionItem.material_description ||
                item.partRequisitionItem.parts_name,
              uom: item.partRequisitionItem.uom,
              qty: item.partRequisitionItem.qty,
              received_quantity: item.received_quantity || 0,
              request_quantity: item.required_quantity,
              material_group: item.partRequisitionItem.material_group,
              material_type: item.partRequisitionItem.material_type,
              pending_quantity: item.pending_quantity,
              product_variant_id: item.productVariant?.id || null,
              make: item.productVariant?.manufacturer?.name,
              rate: String(item.rate),
              gst: item.gst,
              amount: item.amount,
              manufacturer_id: item.manufacturer_id,
              project_id: item.partRequisitionItem.project?.id,
              project_name: item.partRequisitionItem.project?.project_name,
              partRequisitionItem: item.partRequisitionItem,
              productVariant: item.productVariant,
              vendor_id: data.vendor_id,
              vendor_name: data.vendor?.name,
              stock: item.productVariant?.quantity,
              user_draft_id: data.user_draft_id,
              isExcludePo: false,
            })
          );

          setViewPR(transformedItems);

          transformedItems.forEach(
            (item: { product_id: number; manufacturer_id: number }) => {
              if (item.product_id && item.manufacturer_id) {
                fetchRateForProduct(item.product_id, item.manufacturer_id);
              }
            }
          );

          const total = transformedItems.reduce(
            (sum: number, item: any) => sum + (item.amount || 0),
            0
          );
          setTotalAmount(total);

          if (data.terms_condition) {
            let source: any = data.terms_condition;
            if (typeof source === "string") {
              try {
                const parsed = JSON.parse(source);
                if (Array.isArray(parsed)) source = parsed;
              } catch (e) {}
            }
            const termsString = Array.isArray(source)
              ? source.join('\n')
              : String(source ?? "");
            setTermsAndConditions(termsString);
            setTempTerms(termsString);
          }
        }
      })
      .catch((err) => {})
      .finally(() => {
        setLoader(false);
      });
  };

  const fetchPODetailsById = (id: any) => {
    setLoader(true);
    getViewPO(id)
      .then((res) => {
        if (checkStatusCodeSuccess(res?.statusCode)) {
          const data = res?.data;
          setPODetails(data);
          setPartId(data.part_id);
          if (data.repairOrder) {
            setRONumberList([
              {
                label: data.repairOrder.ro_no,
                value: data.ro_id,
              },
            ]);

            setSelectedRONo(data.ro_id);
            formik.setFieldValue("RONumber", data.ro_id);
          }

          if (data.vendor) {
            setSelectedVendor({
              id: data.vendor.id,
              value: data.vendor.id,
              label: data.vendor.name,
              user_draft_id: data.user_draft_id,
              countAmount: 0,
            });
          }

          const transformedItems = data.repairOrderPurchaseOrderItem.map(
            (item: any) => ({
              ...item,
              item_code: item.product?.product_code,
              item_id: item.id,
              parts_name: item.product?.product_description,
              uom: item.partRequisitionItem.uom,
              stock: item.productVariant?.quantity,
              make: item.productVariant?.manufacturer?.name,
              qty: item?.partRequisitionItem.qty,
              material_type: item.partRequisitionItem.material_type,
              material_group: item.partRequisitionItem.material_group,
              material_group_description:
                item.partRequisitionItem.material_group_description,
              store_location: item.partRequisitionItem.store_location,
              rate: String(item.rate),
              rack_location: item.partRequisitionItem.rack_location,
              vendor_id: data.vendor_id,
              vendor_name: data.vendor?.name,
              user_draft_id: data.user_draft_id,
              remarks: item.partRequisitionItem.remarks,
              project_name:
                item.repairOrderPurchaseOrderItem?.project?.project_name,
              product_variant_id: item.productVariant?.id || null,
              isExcludePo: false,
            })
          );

          setViewPR(transformedItems);

          transformedItems.forEach(
            (item: { product_id: number; manufacturer_id: number }) => {
              if (item.product_id && item.manufacturer_id) {
                fetchRateForProduct(item.product_id, item.manufacturer_id);
              }
            }
          );

          const total = transformedItems.reduce(
            (sum: number, item: any) => sum + (item.amount || 0),
            0
          );
          setTotalAmount(total);

          if (data.terms_condition) {
            let source: any = data.terms_condition;
            if (typeof source === "string") {
              try {
                const parsed = JSON.parse(source);
                if (Array.isArray(parsed)) source = parsed;
              } catch (e) {}
            }
            const termsString = Array.isArray(source) 
              ? source.join('\n')
              : source;
            
            setTermsAndConditions(termsString);
            setTempTerms(termsString);
          }
        }
      })
      .catch((err) => {})
      .finally(() => {
        setLoader(false);
      });
  };

  useEffect(() => {
    if (id) {
      fetchPODetailsById(id);
    } else if (prid) {
      fetchPRDetailsById(Number(prid), true);
    } else if (poid) {
      fetchPOWORODetailsById(Number(poid));
    } else {
      setViewPR([]);
    }
  }, [id, prid]);

  useEffect(() => {
    listOfProject()
      .then((res) => {
        if (checkStatusCodeSuccess(res?.statusCode)) {
          const data = res?.data?.project;
          setProjectNames(
            data.map((item: any) => ({
              value: item.id,
              label: item.project_name,
            }))
          );
        } else {
          toast.error(res.message);
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message || err?.message);
      });
  }, []);

  useEffect(() => {
    getRONumberList()
      .then((res) => {
        if (checkStatusCodeSuccess(res?.statusCode)) {
          const data = res?.data;
          setRONumberList(
            data.map((item: any) => ({
              label: item.ro_no,
              value: item.id,
            }))
          );
        } else {
          toast.error(res.message);
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message || err?.message);
      });
  }, []);

  useEffect(() => {
    listOfItemCode({})
      .then((res) => {
        if (checkStatusCodeSuccess(res?.statusCode)) {
          const data = res?.data?.product;
          const formattedItemCodes = data.map((item: any) => ({
            value: item.id,
            label: item.product_code,
          }));
          setItemCodes(formattedItemCodes);
        } else {
          toast.error(res.message);
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message || err?.message);
      });
  }, []);

  const fetchVendorData = () => {
    setLoader(true);
    const payload = {
      sortKey: columnName,
      sortValue: sortOrder,
      page: currentPage,
      type_of_user: vendorLabel,
      limit: customPageSize,
    };
    listOfVendor(payload)
      .then((res) => {
        if (checkStatusCodeSuccess(res?.statusCode)) {
          setVendorData(res?.data?.positions);
        }
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        setLoader(false);
      });
  };

  useEffect(() => {
    fetchVendorData();
  }, []);

  const handleProductSelect = async (
    productCode: string,
    rowIndex: number,
    selectedId: number
  ) => {
    try {
      const response = await listOfProductForItem({
        product_id: selectedId,
      });

      if (response?.statusCode === 200 && response.data?.[0]) {
        const productDetails = response.data[0];

        setViewPR((prevData) => {
          const updatedData = [...prevData];
          updatedData[rowIndex] = {
            ...updatedData[rowIndex],
            product_id: productDetails.id || null,
            parts_name: productDetails.product_description,
            uom: productDetails.uom,
            stock: productDetails.productVariant?.[0]?.quantity,
            make: productDetails.productVariant?.[0]?.manufacturer.name,
            material_type: productDetails.material?.name || "",
            material_group: productDetails.materialGroup?.name || "",
            material_group_description:
              productDetails.material_group_description || "",
            store_location: productDetails.store?.storeAddress?.address || "",
            rack_location: productDetails.rake_no || "",
            manufacturer_id:
              productDetails.productVariant?.manufacturer_id || null,
          };
          return updatedData;
        });
        const currentRow = viewPR[rowIndex];
        await fetchRateForProduct(
          productDetails.id,
          currentRow.manufacturer_id
        );
      } else {
        toast.error(response.message);
      }
    } catch (err: any) {
      toast.error(err.message);
    }
  };

  const countAmount = (data: any, rowIndex: number) => {
    const payload = {
      quantity: data.required_quantity,
      gst: data.gst,
      rate: Number(data.rate),
    };

    const isValidPayload =
      payload.quantity !== null &&
      payload.gst !== null &&
      payload.rate !== null;

    if (isValidPayload) {
      setLoader(true);

      amountCountApi(payload)
        .then((res) => {
          if (checkStatusCodeSuccess(res?.statusCode)) {
            const updatedAmount = res?.data;

            setViewPR((prevData) => {
              const updatedData = [...prevData];
              updatedData[rowIndex] = {
                ...updatedData[rowIndex],
                amount: updatedAmount,
              };
              return updatedData;
            });
            if (gridRef.current?.api) {
              const rowNode =
                gridRef.current.api.getDisplayedRowAtIndex(rowIndex);
              if (rowNode) {
                gridRef.current.api.refreshCells({
                  rowNodes: [rowNode],
                  columns: ["amount"],
                });
              }
            }
          }
        })
        .catch((err) => {
          toast.error(err?.response?.data?.message || err?.message);
        })
        .finally(() => {
          setLoader(false);
        });
    }
  };

  const handleVendorSelection = (newValue: string, rowIndex: number) => {
    if (rowIndex === 0) {
      const selectedVendor = vendorData.find(
        (vendor) => vendor.name === newValue
      );
      if (selectedVendor) {
        setViewPR((prevData) => {
          return prevData.map((row) => ({
            ...row,
            vendor_id: selectedVendor.id,
            vendor_name: selectedVendor.name,
            user_draft_id: selectedVendor.user_draft_id,
          }));
        });
        setSelectedVendor(selectedVendor);
      }
    }
  };

  const handleGSTSelection = (newValue: string, rowIndex: number) => {
    const selectedGST = TaxType.find((tax) => tax.label === newValue);
    if (selectedGST) {
      setViewPR((prevData) => {
        const updatedData = [...prevData];
        updatedData[rowIndex] = {
          ...updatedData[rowIndex],
          gst: selectedGST.value,
        };

        if (
          updatedData[rowIndex].required_quantity &&
          updatedData[rowIndex].rate
        ) {
          countAmount(updatedData[rowIndex], rowIndex);
        }

        return updatedData;
      });
    }
  };

  const fetchMake = async () => {
    setLoader(true);
    try {
      const res = await listOfManufacturer({});
      if (checkStatusCodeSuccess(res?.statusCode)) {
        const data = res?.data?.manufacturers?.map((item: any) => ({
          value: item?.id,
          label: item?.name,
          id: item?.id,
        }));
        data.push({ value: "add_new", label: ADD_NEW_MAKE, id: "add_new" });
        setMakeOption(data);
      } else {
        setMakeOption([
          { value: "add_new", label: ADD_NEW_MAKE, id: "add_new" },
        ]);
      }
    } catch (err: any) {
      toast.error(err?.response?.data?.message || err?.message);
      setMakeOption([{ value: "add_new", label: ADD_NEW_MAKE, id: "add_new" }]);
    } finally {
      setLoader(false);
    }
  };
  useEffect(() => {
    fetchMake();
  }, []);

  const fetchRateForProduct = async (
    productId: number,
    manufacturerId: number
  ) => {
    try {
      const payload = {
        product_id: productId,
        makeId: manufacturerId,
      };

      const res = await listOfRate(payload);
      if (checkStatusCodeSuccess(res?.statusCode)) {
        const data = res?.data
          ?.filter((item: any) => item?.rate !== null)
          .map((item: any) => ({
            value: String(item?.rate),
            label: String(item?.rate),
            // rate: String(item?.rate),
            id: item?.id,
          }));

        data.push({
          value: "",
          label: ADD_RATE_LABEL,
          id: 0,
          // rate: "",
        });

        setRateOptions((prev) => ({
          ...prev,
          [productId]: data,
        }));

        if (gridRef.current?.api) {
          gridRef.current.api.refreshCells({ force: true });
        }
      } else {
        setRateOptions((prev) => ({
          ...prev,
          [productId]: [
            {
              value: "",
              label: ADD_RATE_LABEL,
              id: 0,
            },
          ],
        }));
      }
    } catch (err: any) {
      toast.error(err?.response?.data?.message || err?.message);
      setRateOptions((prev) => ({
        ...prev,
        [productId]: [
          {
            value: "",
            label: ADD_RATE_LABEL,
            id: 0,
            // rate: "",
          },
        ],
      }));
    }
  };

  const fetchStock = async (Id: number) => {
    setLoader(true);
    try {
      const res = await listOfStock(Id);
      if (checkStatusCodeSuccess(res?.statusCode)) {
        return res?.data?.quantity || 0;
      } else {
        return 0;
      }
    } catch (err: any) {
      toast.error(err?.response?.data?.message || err?.message);
      return 0;
    } finally {
      setLoader(false);
    }
  };

  const handleEditTerms = () => {
    setTempTerms(termsAndConditions);
    setIsEditingTerms(true);
  };

  const handleSaveTerms = () => {
    setTermsAndConditions(tempTerms);
    setIsEditingTerms(false);
  };

  const handleCancelTerms = () => {
    setTempTerms(termsAndConditions);
    setIsEditingTerms(false);
  };

  const makeForm = useFormik({
    initialValues: {
      name: "",
    },
    validationSchema: makeValidationSchema,
    onSubmit: async (values) => {
      setModalLoader(true);

      const payload = {
        name: values.name,
      };
      createManufacturer(payload)
        .then((res) => {
          if (checkStatusCodeSuccess(res?.statusCode)) {
            toast.success(res?.message);
            setMakeModal(false);
            const newMakeName = values.name;

            listOfManufacturer({})
              .then((makeRes) => {
                if (checkStatusCodeSuccess(makeRes?.statusCode)) {
                  const manufacturers = makeRes?.data?.manufacturers || [];
                  const formattedData = manufacturers.map((item: any) => ({
                    value: item?.id,
                    label: item?.name,
                    id: item?.id,
                  }));
                  formattedData.push({
                    value: "add_new",
                    label: ADD_NEW_MAKE,
                    id: "add_new",
                  });
                  setMakeOption(formattedData);

                  const newMake = manufacturers.find(
                    (m: any) => m.name === newMakeName
                  );

                  if (newMake && currentEditingCell) {
                    const { rowIndex } = currentEditingCell;

                    setViewPR((prevData) => {
                      const updatedData = [...prevData];
                      if (updatedData[rowIndex]) {
                        updatedData[rowIndex] = {
                          ...updatedData[rowIndex],
                          make: newMakeName,
                          manufacturer_id: newMake.id,
                        };

                        if (updatedData[rowIndex].product_id) {
                          fetchRateForProduct(
                            updatedData[rowIndex].product_id,
                            newMake.id
                          );
                        }
                      }
                      return updatedData;
                    });

                    if (gridRef.current?.api) {
                      setTimeout(() => {
                        gridRef.current?.api?.refreshCells({
                          force: true,
                          columns: ["make"],
                        });
                      }, 100);
                    }
                  }
                }
              })
              .catch((err) => {
                toast.error(err?.response?.data?.message || err?.message);
              });

            makeForm.resetForm();
          } else {
            toast.error(res?.message);
          }
        })
        .catch((error) => {
          toast.error(error?.response?.data?.message || error?.message);
        })
        .finally(() => setModalLoader(false));
    },
  });

  const rateForm = useFormik({
    initialValues: {
      rate: "",
      product_id: null as number | null,
      manufacturer_id: null as number | null,
      item_id: null as number | null,
    },
    validationSchema: rateValidationSchema,
    onSubmit: async (values) => {
      setModalLoader(true);

      const payload = {
        product_id: values.product_id,
        makeId: values.manufacturer_id || 1,
        rate: parseFloat(values.rate),
        item_id: values.item_id,
      };

      try {
        const res = await addRate(payload);
        if (checkStatusCodeSuccess(res?.statusCode)) {
          toast.success(res?.message);
          setRateModal(false);
          const newRateValue = values.rate;
          const productId = values.product_id;
          const manufacturerId = values.manufacturer_id;

          if (productId) {
            await fetchRateForProduct(productId, payload.makeId);

            setTimeout(() => {
              if (gridRef.current?.api && currentEditingCell) {
                const { rowIndex } = currentEditingCell;

                setViewPR((prevData) => {
                  const updatedData = [...prevData];
                  if (updatedData[rowIndex]) {
                    updatedData[rowIndex] = {
                      ...updatedData[rowIndex],
                      rate: String(newRateValue),
                    };

                    countAmount(updatedData[rowIndex], rowIndex);
                  }
                  return updatedData;
                });

                gridRef.current.api.refreshCells({ force: true });
              }
            }, 300);
          }

          rateForm.resetForm();
        } else {
          toast.error(res?.message);
        }
      } catch (error: any) {
        toast.error(error?.response?.data?.message || error?.message);
      } finally {
        setModalLoader(false);
      }
    },
  });

  const updateRowData = (rowIndex: number, newData: any) => {
    setViewPR((prevData) => {
      const newArray = [...prevData];
      newArray[rowIndex] = newData;
      return newArray;
    });
  };

  const PartRequisitionColumns = useMemo(
    () => [
      {
        headerName: SELECT_LABEL,
        checkboxSelection: !isViewMode && !isViewPORoute,
        headerCheckboxSelection: !isViewMode || !isViewPORoute,
        headerCheckboxSelectionFilteredOnly: !isViewMode || !isViewPORoute,
        width: 150,
        flex: 1.5,
        hide: isViewMode || isViewPORoute,
      },
      {
        headerName: SR_NO_LABEL,
        field: "srNo",
        valueGetter: "node.rowIndex + 1",
        flex: 1.5,
        minWidth: 150,
      },
      {
        headerName: VENDOR_NAME_LABEL,
        headerClass: "required",
        field: "vendor_name",
        editable: (params: any) =>
          !isViewMode && !isViewPORoute && params.node.rowIndex === 0,
        flex: 1.5,
        minWidth: 150,
        sortable: true,
        cellEditor: "agSelectCellEditor",
        cellEditorParams: {
          values: vendorData.map((vendor) => vendor.name),
        },
        onCellValueChanged: (event: any) => {
          const { newValue, node } = event;
          handleVendorSelection(newValue, node.rowIndex);
        },
        cellStyle: (
          params: any
        ): { backgroundColor?: string; cursor?: string } => {
          return params.node.rowIndex === 0 ? {} : { cursor: "not-allowed" };
        },
      },
      {
        headerName: VENDOR_ID_LABEL,
        field: "user_draft_id",
        editable: false,
        flex: 1.5,
        minWidth: 150,
        sortable: true,
        cellStyle: { cursor: "not-allowed" },
      },
      {
        headerName: ITEM_CODE_LABEL,
        field: "item_code",
        editable: true,
        flex: 1.5,
        minWidth: 180,
        sortable: true,
        cellEditor: (params: any) => {
          return (
            <ItemCodeEditor
              params={{
                ...params,
                itemCodes,
                context: {
                  handleProductSelect,
                  updateRowData,
                },
              }}
            />
          );
        },
        cellEditorPopup: true,
        valueFormatter: (params: { value: string }) => {
          return params.value || "";
        },
      },
      {
        headerName: ITEM_DESC_LABEL,
        field: "parts_name",
        editable: false,
        flex: 1.5,
        minWidth: 150,
        sortable: true,
        hide: isPRRoute || isEditPORoute || isViewPORoute,
      },
      {
        headerName: UOM_LABEL,
        field: "uom",
        editable: false,
        flex: 1.5,
        minWidth: 150,
        sortable: true,
        hide: isPRRoute || isEditPORoute || isViewPORoute,
      },
      {
        headerName: REQUESTED_QTY_LABEL,
        field: "qty",
        editable: !isViewMode && !isViewPORoute,
        flex: 1.5,
        minWidth: 150,
        valueParser: (params: any) => {
          const value = params.newValue;
          return value ? parseFloat(value) : 0;
        },
      },
      {
        headerName: STOCK_LABEL,
        field: "stock",
        editable: false,
        flex: 1.5,
        minWidth: 150,
        sortable: true,
        valueParser: (params: any) => {
          const value = params.newValue;
          return value ? parseFloat(value) : 0;
        },
      },
      {
        headerName: MAKE_LABEL,
        field: "make",
        editable: true,
        headerClass: "required",
        flex: 1.5,
        minWidth: 150,
        cellEditor: "agSelectCellEditor",
        cellEditorParams: {
          values: makeOption?.map((option: any) => option?.label),
          formatValue: (value: any) => {
            const selectedOption = makeOption?.find(
              (opt) => opt?.label === value
            );
            return selectedOption ? selectedOption?.label : value;
          },
        },
        onCellClicked: (params: any) => {
          setCurrentEditingCell({
            rowIndex: params.node.rowIndex,
            productId: params.data.product_id,
            manufacturerId: params.data.manufacturer_id,
            itemId: params.data.item_id,
          });
        },
        valueSetter: (params: any) => {
          const selectedValue = params.newValue;
          const selectedOption = makeOption?.find(
            (opt) => opt?.label === selectedValue
          );
          if (selectedOption) {
            if (selectedOption?.label === ADD_NEW_MAKE) {
              setMakeModal(true);
              return false;
            } else {
              params.data[MAKE_KEY] = selectedOption?.label;
              params.data.manufacturer_id = selectedOption.id;

              if (params.data.product_id) {
                fetchRateForProduct(params.data.product_id, selectedOption.id);
              }
            }
            return true;
          }
          return false;
        },
      },
      {
        headerName: REQUIRED_STOCK_LABEL,
        field: "required_quantity",
        editable: !isViewMode && !isViewPORoute,
        headerClass: "required",
        flex: 1.5,
        minWidth: 150,
        sortable: true,
        valueParser: (params: any) => {
          const value = params.newValue;
          return value ? parseFloat(value) : 0;
        },
        valueSetter: (params: any) => {
          const newValue = parseFloat(params.newValue);
          if (!isNaN(newValue)) {
            params.data.required_quantity = newValue;
            countAmount(params.data, params.node.rowIndex);
            return true;
          }
          return false;
        },
      },
      {
        headerName: PROJECT_NAME_LABEL,
        headerTooltip: PROJECT_NAME_LABEL,
        field: "project_name",
        tooltipField: "project_name",
        editable: false,
        sortable: true,
        flex: 1.5,
        minWidth: 150,
        cellEditor: "agSelectCellEditor",
        cellEditorParams: {
          values: projectNames.map((item) => item.label),
          valueField: "value",
          displayField: "label",
        },
        valueSetter: (params: any) => {
          const selectedProject = projectNames.find(
            (item) => item.label === params.newValue
          );
          if (selectedProject) {
            params.data.project_name = selectedProject.label;
            params.data.project_id = selectedProject.value;
            return true;
          }
          params.data.project_name = "";
          params.data.project_id = null;
          return true;
        },
      },
      {
        headerName: RATE_LABEL,
        field: "rate",
        headerClass: "required",
        editable: !isViewMode && !isViewPORoute,
        flex: 1.5,
        minWidth: 150,
        sortable: true,
        cellEditor: "agSelectCellEditor",
        cellEditorParams: (params: any) => {
          const productId = params.data?.product_id;
          const options = rateOptions[productId] || [];
          return {
            values: options.map((option) => option.label),
          };
        },
        onCellClicked: (params: any) => {
          setCurrentEditingCell({
            rowIndex: params.node.rowIndex,
            productId: params.data.product_id,
            manufacturerId: params.data.manufacturer_id,
            itemId: params.data.item_id,
          });
        },
        valueSetter: (params: any) => {
          const productId = params.data?.product_id;
          if (!productId) return false;

          const options = rateOptions[productId] || [];
          const selectedValue = params.newValue;
          const selectedOption = options.find(
            (opt) => opt.label === selectedValue
          );

          if (!selectedOption) return false;

          if (selectedOption.label === ADD_RATE_LABEL) {
            rateForm.setValues({
              product_id: Number(productId),
              manufacturer_id: Number(params.data.manufacturer_id),
              item_id: Number(params.data.item_id),
              rate: "",
            });
            setRateModal(true);
            return false;
          }

          const updatedData = {
            ...params.data,
            rate: selectedOption.value,
            product_variant_id: selectedOption.id,
          };

          params.node.setData(updatedData);
          params.api.refreshCells({ rowNodes: [params.node], force: true });

          fetchStock(selectedOption.id).then((stockValue) => {
            setViewPR((prevData) =>
              prevData.map((row, index) =>
                index === params.node.rowIndex
                  ? {
                      ...row,
                      stock: stockValue,
                      rate: selectedOption.value,
                      product_variant_id: selectedOption.id,
                    }
                  : row
              )
            );
          });

          countAmount(updatedData, params.node.rowIndex);
          return true;
        },
      },
      {
        headerName: GST_LABEL,
        field: "gst",
        headerClass: "required",
        editable: !isViewMode && !isViewPORoute,
        cellEditor: "agSelectCellEditor",
        cellEditorParams: {
          values: TaxType?.map((option) => option?.label),
        },
        valueSetter: (params: any) => {
          const newValue = params.newValue;
          const selectedOption = TaxType?.find(
            (opt) => opt?.label === newValue
          );
          if (selectedOption) {
            handleGSTSelection(newValue, params.node.rowIndex);
            return true;
          }
          return false;
        },
        valueGetter: (params: any) => {
          if (!params.data) return "";
          const selectedOption = TaxType?.find(
            (opt) => opt?.value === (params.data.gst ?? null)
          );
          return selectedOption ? selectedOption.label : "";
        },
        flex: 1.5,
        minWidth: 150,
        sortable: true,
      },
      {
        headerName: AMOUNT_LABEL,
        field: "amount",
        editable: false,
        flex: 1.5,
        minWidth: 150,
        sortable: true,
        valueFormatter: (params: any) => {
          if (params.value != null) {
            return rupeeSymbol(params.value.toFixed(2));
          }
          return rupeeSymbol("0.00");
        },
      },
      {
        headerName: STORE_LOCA_LABEL,
        field: "store_location",
        editable: !isViewMode && !isViewPORoute,
        flex: 1.5,
        minWidth: 150,
        hide: isPRRoute || isEditPORoute || isViewPORoute,
      },
      {
        headerName: PROJECT_NAME_LABEL,
        field: "project_name",
        tooltipField: "project_name",
        editable: !isViewMode && !isViewPORoute,
        sortable: true,
        flex: 1.5,
        minWidth: 150,
        cellEditor: "agSelectCellEditor",
        cellEditorParams: {
          values: projectNames.map((item) => item.label),
          valueField: "value",
          displayField: "label",
        },
        hide: isPRRoute || isEditPORoute || isViewPORoute,
      },
      {
        headerName: RACK_LOCA_LABEL,
        field: "rack_location",
        editable: !isViewMode && !isViewPORoute,
        flex: 1.5,
        minWidth: 150,
        hide: isPRRoute || isEditPORoute || isViewPORoute,
      },
      {
        headerName: RAMARKS_LABEL,
        field: "remarks",
        editable: !isViewMode && !isViewPORoute,
        flex: 1.5,
        minWidth: 150,
        hide: isPRRoute || isEditPORoute || isViewPORoute,
      },
      {
        headerName: MATERIAL_TYPE_LABEL,
        field: "material_type",
        editable: false,
        flex: 1.5,
        minWidth: 150,
        hide: isPRRoute || isEditPORoute || isViewPORoute,
      },
      {
        headerName: MATERIAL_GRP_LABEL,
        field: "material_group",
        editable: false,
        flex: 1.5,
        minWidth: 150,
        hide: isPRRoute || isEditPORoute || isViewPORoute,
      },
      {
        headerName: MATERIAL_DESC_LABEL,
        field: "material_group_description",
        editable: false,
        flex: 1.5,
        minWidth: 200,
        hide: isPRRoute || isEditPORoute || isViewPORoute,
      },
    ],
    [
      itemCodes,
      projectNames,
      vendorData,
      isViewMode,
      makeOption,
      rateOptions,
      rateForm.values,
    ]
  );

  const handleSelectionChanged = () => {
    if (!isViewMode) {
      const selectedRows = gridRef.current!.api.getSelectedRows();
      const total = selectedRows.reduce(
        (sum: number, row: any) => sum + (row.amount || 0),
        0
      );
      setTotalAmount(total);
    }
  };

  const validateGridData = (selectedRows: any[]) => {
    let hasEmptyFields = false;

    if (!selectedVendor) {
      hasEmptyFields = true;
    }

    selectedRows.forEach((row) => {
      if (
        row.required_quantity === undefined ||
        row.required_quantity === null ||
        row.rate === undefined ||
        row.rate === null ||
        !row.gst ||
        !row.make
      ) {
        hasEmptyFields = true;
      }
    });

    return hasEmptyFields;
  };

  const handleSubmit = async (values: any) => {
    const selectedRows = gridRef.current?.api.getSelectedRows() || [];

    const hasEmptyFields = validateGridData(selectedRows);
    if (hasEmptyFields) {
      toast.error(ALL_FIELDS_ARE_REQUIRED);
      return;
    }

    if (selectedRows.length === 0) {
      toast.error(PLEASE_SELECT_ONE_ROW);
      return;
    }

    const purchaseOrderItems = selectedRows.map((row: any) => ({
      id: row.id,
      product_id: row.product_id ? Number(row.product_id) : null,
      manufacturer_id: row.manufacturer_id,
      part_item_id: row.part_item_id || row.id,
      project_id: row.project_id,
      rate: Number(row.rate) || 0,
      gst: row.gst || "",
      request_quantity: row.qty ? parseFloat(row.qty) : 0,
      required_quantity: row.qty ? parseFloat(row.required_quantity) : 0,
      amount: row.amount || 0,
      remarks: row.remarks || "",
      product_variant_id: row.product_variant_id,
      isExcludePo: true,
    }));

    const termsArray = termsAndConditions
      .split('\n')
      .filter(term => term.trim() !== '')
      .map(term => term.trim());

    const payload = {
      part_id: partId,
      ro_id: Number(selectedRONo),
      vendor_id: selectedVendor?.id,
      user_draft_id: selectedVendor?.user_draft_id,
      purchaseOrderItem: purchaseOrderItems,
      total_amount: totalAmount,
      terms_condition: termsArray,
    };

    if (id || poid) {
      setBtnLoader(true);
      updatePO(Number(id || poid), payload)
        .then((res) => {
          if (checkStatusCodeSuccess(res?.statusCode)) {
            toast.success(res?.message);
            poid ? navigate("/purchase-order") : navigate("/RoPurchaseOrder");
          } else {
            toast.error(res?.message);
          }
        })
        .catch((err) => {
          toast.error(err?.response?.data?.message || err?.message);
        })
        .finally(() => {
          setBtnLoader(false);
        });
    } else {
      try {
        setBtnLoader(true);
        const response = await addPOwithRO(payload);
        if (checkStatusCodeSuccess(response?.statusCode)) {
          toast.success(response.message);
          isPRRoute
            ? navigate("/purchase-order")
            : navigate("/RoPurchaseOrder");
          fetchRODetailsById(selectedRONo, true);
        } else {
          toast.error(response.message);
        }
      } catch (err: any) {
        toast.error(err?.response?.data?.message || err?.message);
      } finally {
        setBtnLoader(false);
      }
    }
  };

  const formik = useFormik({
    initialValues: {
      RONumber: "",
      qty: "",
      rate: "",
    },
    validationSchema,
    onSubmit: handleSubmit,
  });

  const handleRONumberChange = (value: any) => {
    setSelectedRONo(value);
    setViewPR([]);
    if (value) {
      fetchRODetailsById(value, true);
    } else {
      setViewPR([]);
    }
  };

  document.title = getPageTitle();

  return (
    <div
      className="page-content"
      style={{ cursor: isViewMode || isViewPORoute ? "not-allowed" : "auto" }}
    >
      {loader && <Loader />}
      <div className="flex-grow-1 mx-3">
        <div className="mb-1 mx-2 d-flex justify-content-between align-items-center">
          <span className="fs-4 d-flex gap-4">{getPageTitle()}</span>
          <button
            className="btn btn-danger"
            onClick={() =>
              navigate(
                isViewPORoute
                  ? "/purchase-order"
                  : isEditPORoute
                  ? "/purchase-order"
                  : isPRRoute
                  ? "/indentation"
                  : "/RoPurchaseOrder"
              )
            }
          >
            <i className="mdi mdi-arrow-left" />
          </button>
        </div>
        <div className="card word-wrap">
          <div className="card-body">
            <form onSubmit={formik.handleSubmit}>
              <div className="row">
                {!isEditPORoute &&
                  !isPRRoute &&
                  !isViewPRRoute &&
                  !isViewPORoute && (
                    <div
                      className="col-md-3 col-sm-6 col-12 mb-4"
                      style={{ cursor: isViewMode ? "not-allowed" : "auto" }}
                    >
                      <BaseSelect
                        name="RONumber"
                        label={RO_NO_LABEL}
                        options={RONumberList}
                        value={formik.values.RONumber}
                        handleChange={(field: any, value: any) => {
                          if (!isViewMode) {
                            formik.setFieldValue(field, value);
                            handleRONumberChange(value);
                          }
                        }}
                        handleBlur={formik.handleBlur}
                        error={formik.errors.RONumber}
                        touched={formik.touched.RONumber}
                        required
                        disabled={!!id || isViewMode}
                        style={{ pointerEvents: isViewMode ? "none" : "auto" }}
                      />
                    </div>
                  )}
              </div>

              <div className="table-css">
                <div className="ag-theme-quartz">
                  <AgGridReact
                    ref={gridRef}
                    rowData={viewPR}
                    columnDefs={PartRequisitionColumns}
                    rowSelection={isViewMode ? undefined : "multiple"}
                    suppressRowClickSelection={true}
                    defaultColDef={{
                      sortable: true,
                      resizable: true,
                      flex: 1,
                      tooltipComponentParams: {
                        color: "blue",
                      },
                    }}
                    domLayout="normal"
                    getRowHeight={() => 35}
                    overlayNoRowsTemplate={notFound.dataNotFound}
                    onSelectionChanged={handleSelectionChanged}
                  />
                </div>
                <div className="d-flex justify-content-end align-items-start">
                  <div className="mt-4 d-flex gap-4">
                    <div className=" flex-column text-start">
                      <h6 className="mb-1 font-bold text-dark">
                        {QuotationLabel.TotalGSTAmount}
                      </h6>
                      <span className="text-center">
                        {rupeeSymbol(totalAmount.toFixed(2))}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row mt-4">
                <div className="col-12">
                  <div className="card border-primary">
                    <div className="card-header text-black d-flex justify-content-between align-items-center">
                      <h5 className="card-title mb-0">
                        <i className="mdi mdi-file-document-outline me-2"></i>
                        {TERMS_AND_CONDITIONS_LABEL}
                      </h5>
                      {!isViewMode && !isViewPORoute && (
                        <div>
                          {isEditingTerms ? (
                            <div className="d-flex gap-2">
                              <BaseButton
                                type="button"
                                label={SAVE_TERMS_LABEL}
                                color="success"
                                size="sm"
                                onClick={handleSaveTerms}
                                startIcon={<i className="mdi mdi-content-save"></i>}
                              />
                              <BaseButton
                                type="button"
                                label={CANCEL_TERMS_LABEL}
                                color="secondary"
                                size="sm"
                                onClick={handleCancelTerms}
                                startIcon={<i className="mdi mdi-close"></i>}
                              />
                            </div>
                          ) : (
                            <BaseButton
                              type="button"
                              label={EDIT_TERMS_LABEL}
                              color="light"
                              size="sm"
                              onClick={handleEditTerms}
                              startIcon={<i className="mdi mdi-pencil"></i>}
                            />
                          )}
                        </div>
                      )}
                    </div>
                    <div className="card-body">
                      {isEditingTerms ? (
                        <textarea
                          className="form-control terms-textarea"
                          rows={12}
                          value={tempTerms}
                          onChange={(e) => setTempTerms(e.target.value)}
                        />
                      ) : (
                        <ol className="terms-content ">
                          {termsList.map((item, idx) => (
                            <li key={idx}>{item}</li>
                          ))}
                        </ol>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              {!isViewMode && !isViewPORoute && (
                <div className="d-flex justify-content-end mb-1 mt-4 w-100">
                  <div className="col-12 d-flex justify-content-end mb-0">
                    <BaseButton
                      type="submit"
                      label={label}
                      color="success"
                      loader={btnLoader}
                      disable={btnLoader}
                    />
                  </div>
                </div>
              )}
            </form>
          </div>
          <BaseModal
            open={makeModal}
            toggle={() => {
              setMakeModal(!makeModal);
              makeForm.resetForm();
            }}
            submit={() => makeForm.handleSubmit()}
            title={addMakeLabel}
            closeLabel={NoLabel}
            submitLabel={YesLabel}
            closeLabelColor="danger"
            submitLabelColor="success"
            loader={modalLoader}
            size="sm"
          >
            <div className="form-group">
              <BaseInput
                type="text"
                label={MAKE_NAME}
                placeholder={InputPlaceHolder(MAKE_NAME)}
                name="name"
                className="form-control"
                value={makeForm.values.name}
                onChange={makeForm.handleChange}
                handleBlur={makeForm.handleBlur}
                touched={makeForm.touched.name}
                error={makeForm.errors.name}
                required
              />
            </div>
          </BaseModal>

          <BaseModal
            open={rateModal}
            toggle={() => {
              setRateModal(!rateModal);
              rateForm.resetForm();
            }}
            submit={() => rateForm.handleSubmit()}
            title={ADD_RATE_LABEL}
            closeLabel={NoLabel}
            submitLabel={YesLabel}
            closeLabelColor="danger"
            submitLabelColor="success"
            loader={modalLoader}
            size="sm"
          >
            <div className="form-group">
              <BaseInput
                type="number"
                label={RATE_LABEL}
                placeholder={InputPlaceHolder(RATE_LABEL)}
                name="rate"
                className="form-control"
                value={rateForm.values.rate}
                onChange={rateForm.handleChange}
                handleBlur={rateForm.handleBlur}
                touched={rateForm.touched.rate}
                error={rateForm.errors.rate}
                required
              />
            </div>
          </BaseModal>
        </div>
      </div>
    </div>
  );
};

export default RoPOForm;
